import React, { useState, useEffect } from 'react';

import { postpayData } from 'lib/api/sales';

import FilterWrap from 'components/atoms/FilterWrap';
import TableContainer from 'components/molecules/MbTable';
import StatisticsCommonFilter from 'components/organisms/StatisticsCommonFilter';

import UploadModal from './uploadModal';

let initialization = false;
let initParam = {};

const Postpay = () => {
  // 공통 필터에서 초기값 받아왔는지 확인
  const [getInitParam, setGetInitParam] = useState(false);
  const [params, setParams] = useState(initParam);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // 렌더링 후에 실행됨
    // params setting(필터링 혹은 초기 param setting) > 렌더링 > 초기화 값 초기화
    initialization = false;
  }, [params]);

  // header 및 body 컬럼 커스텀
  const customized = {};

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    initialization = true;
    setParams(initParam);
  };

  const handleOnUpload = () => {
    setIsOpen(true);
  };

  const handleToggleModal = (flag) => {
    setIsOpen(flag);
  };

  const getParam = (newParams) => {
    if (getInitParam === false) {
      initParam = {
        ...initParam,
        ...newParams,
      };
    }
    setGetInitParam(true);
    setParams({
      ...params,
      ...newParams,
    });
  };

  return (
    <>
      <FilterWrap handleOnReset={handleOnReset} handleOnUpload={handleOnUpload}>
        <StatisticsCommonFilter
          initialization={initialization}
          getParam={getParam}
          initData={initParam}
          noneExternalFilter={true}
          noneDisplayFilter={true}
          nonePltfomTpCodeFilter={true}
        />
      </FilterWrap>
      {getInitParam && (
        <>
          <TableContainer
            dataReqPromise={postpayData}
            params={{ ...params }}
            sort="asc"
            order="STATS_MTH"
            dense={true}
            customized={customized}
            hasExcel
            hasTotal
          />
        </>
      )}
      <UploadModal
        isOpen={isOpen}
        handleToggleModal={handleToggleModal}
      ></UploadModal>
    </>
  );
};

export default Postpay;
